import * as enums from '@worldfavor/constants/enums'

(function() {
    'use strict'

    angular
        .module('wf.common')
        .directive('wfExportCsv', wfExportCsv)

    wfExportCsv.$inject = []
    function wfExportCsv() {
        const directive = {
            templateUrl(element, attrs) {
                if ('skipButton' in attrs) return 'scripts/wf/importExport/csvExportPopover.template.html'
                else return 'scripts/wf/importExport/wfExportCsv.directive.html'
            },
            bindToController: true,
            controller: wfExportCsvController,
            controllerAs: 'vm',
            restrict: 'EA',
            scope: {
                items: '<',
                itemsOnlyLatestData: '=',
                mapping: '=',
                filenamePart: '=filename',
                customizations: '=',
                topOptions: '=?',
                onResetCustomizations: '&',
                onChangedCustomizations: '=',
                network: '=',
            },
        }
        return directive
    }

    wfExportCsvController.$inject = ['$scope', '$element', 'importExportService', '$translate', '$attrs', '$timeout', 'dataOperationsService', 'apiProxy', '$q', 'wfAuth']
    function wfExportCsvController($scope, $element, importExportService, $translate, $attrs, $timeout, dataOps, apiProxy, $q, wfAuth) {
        const vm = this
        let mappingProperties = []

        const currentSolution = wfAuth.getSolution()

        _.assign(vm, {
            //Variables
            isTransparencySolution: !currentSolution || currentSolution === 'Transparency',
            exportingDetails: {},
            popoverTemplate: 'scripts/wf/importExport/csvExportPopover.template.html',
            numberOfSelectedColumns: 0,
            exporting: false,
            fieldSeparator: ',',
            decimalSeparator: '.',
            textDelimiter: '"',
            dateTimeFormat: 'YYYY-MM-DD HH:mm',
            fieldSeparators: [
                { value: ',', text: $translate.instant('modules.export.csv.popover.comma'), class: 'btn-primary' },
                { value: ';', text: $translate.instant('modules.export.csv.popover.semiColon'), class: 'btn-hollow' },
            ],
            decimalSeparators: [
                { value: '.', text: $translate.instant('modules.export.csv.popover.dot'), class: 'btn-primary' },
                { value: ',', text: $translate.instant('modules.export.csv.popover.comma'), class: 'btn-hollow' },
            ],
            textDelimiters: [
                { value: '"', text: $translate.instant('modules.export.csv.popover.doubleQuotes'), class: 'btn-primary' },
                { value: '\'', text: $translate.instant('modules.export.csv.popover.singleQuotes'), class: 'btn-hollow' },
            ],
            dateTimeFormats: [
                { value: 'YYYY-MM-DD HH:mm', text: $translate.instant('No'), class: 'btn-primary' },
                { value: 'YYYY-MM-DD HH:mm:ss', text: $translate.instant('Yes'), class: 'btn-hollow' },
            ],
            shouldSaveCustomizations: false,
            labelForSavingCustomizations: $translate.instant('modules.export.csv.popover.saveCustomizations') + '\n' + $translate.instant(`modules.export.csv.popover.resourceTypes.${vm.customizations.resourceType}`),

            //Functions
            initExportToCsvConfigUI,
            exportDataToCsv,
            onToggleColumn: () => {
                countSelectedColumns()
                handleChangedCustomizations()
            },
            onHeaderChange: _.throttle(() => {
                handleChangedCustomizations()
            }, 1000),
            setFieldSeparator,
            setDecimalSeparator,
            setTextDelimiter,
            setDateTimeFormat,
            setSaveCustomizationsOption,
            resetCustomizations,
        })

        if ('skipButton' in $attrs) { // If true the export UI is shown directly in the wf-export-csv element instead of in a popover triggered by a button
            initExportToCsvConfigUI()

            const itemsWatcher = $scope.$watchCollection('vm.items', () => {
                vm.actualItems = vm.items
                initExportToCsvConfigUI()
            })

            $scope.$on('$destroy', () => {
                itemsWatcher()
            })
        }

        if (vm.itemsOnlyLatestData && vm.itemsOnlyLatestData.length) {
            vm.showOnlyLatestDataCheckbox = true

            vm.onOnlyExportLatestDataChange = function () {
                if (vm.onlyExportLatestData) {
                    vm.actualItems = vm.itemsOnlyLatestData
                }
                else {
                    vm.actualItems = vm.items
                }

                vm.exportingDetails.numberOfItems = vm.actualItems.length
                vm.numberOfRowsText = $translate.instant('modules.export.csv.popover.rows') + ': ' + vm.exportingDetails.numberOfItems
                $timeout()
            }
        }

        function countSelectedColumns() {
            vm.numberOfSelectedColumns = _.filter(vm.exportingDetails.mappingOptions, 'include').length
            vm.numberOfColumnsText = $translate.instant('modules.export.csv.popover.columns') + ': ' + vm.numberOfSelectedColumns
        }

        function initExportToCsvConfigUI() {
            if (vm.onlyExportLatestData) {
                vm.actualItems = vm.itemsOnlyLatestData
            }
            else {
                vm.actualItems = vm.items
            }

            if (_.isEmpty(vm.exportingDetails)) {
                vm.defaultMappingOptions = Object.entries(vm.mapping).map(([key, column]) => {
                    return { header: column.header, include: column.include, property: key }
                })

                if (vm.customizations && vm.customizations.mapping) {
                    Object.entries(vm.customizations.mapping).forEach(([key, column]) => {
                        const mappingEntry = vm.mapping[key]
                        if (mappingEntry) {
                            mappingEntry.include = column.include
                            mappingEntry.header = column.header
                        }
                    })
                }

                vm.exportingDetails = { numberOfItems: vm.actualItems.length, mappingOptions: vm.mapping }
                countSelectedColumns()
            }
            vm.exportingDetails.numberOfItems = vm.items.length
            vm.numberOfRowsText = $translate.instant('modules.export.csv.popover.rows') + ': ' + vm.exportingDetails.numberOfItems

            if (vm.customizations) {
                if (vm.customizations.settings) {
                    vm.fieldSeparator = vm.customizations.settings.fieldSeparator || vm.fieldSeparator
                    vm.decimalSeparator = vm.customizations.settings.decimalSeparator || vm.decimalSeparator
                    vm.textDelimiter = vm.customizations.settings.textDelimiter || vm.textDelimiter
                    vm.dateTimeFormat = vm.customizations.settings.dateTimeFormat || vm.dateTimeFormat
                }

                vm.shouldSaveCustomizations = vm.customizations.hasOwnProperty('shouldSaveCustomizations') ? vm.customizations.shouldSaveCustomizations : vm.shouldSaveCustomizations
            }
        }

        function resetCustomizations() {
            if (vm.onResetCustomizations) vm.onResetCustomizations()
        }

        function handleChangedCustomizations() {
            if (vm.onChangedCustomizations) {
                vm.onChangedCustomizations({
                    shouldSaveCustomizations: vm.shouldSaveCustomizations,
                    mapping: vm.exportingDetails.mappingOptions,
                    settings: {
                        fieldSeparator: vm.fieldSeparator,
                        decimalSeparator: vm.decimalSeparator,
                        textDelimiter: vm.textDelimiter,
                        dateTimeFormat: vm.dateTimeFormat,
                    },
                })
            }
        }

        function setFieldSeparator(button) {
            vm.fieldSeparator = button.value
            button.class = 'btn-primary'
            _.each(_.without(vm.fieldSeparators, button), (btn) => {
                btn.class = 'btn-hollow'
            })
            handleChangedCustomizations()
        }

        function setDecimalSeparator(button) {
            vm.decimalSeparator = button.value
            button.class = 'btn-primary'
            _.each(_.without(vm.decimalSeparators, button), (btn) => {
                btn.class = 'btn-hollow'
            })
            handleChangedCustomizations()
        }

        function setTextDelimiter(button) {
            vm.textDelimiter = button.value
            button.class = 'btn-primary'
            _.each(_.without(vm.textDelimiters, button), (btn) => {
                btn.class = 'btn-hollow'
            })
            handleChangedCustomizations()
        }

        function setDateTimeFormat(button) {
            vm.dateTimeFormat = button.value
            button.class = 'btn-primary'
            _.each(_.without(vm.dateTimeFormats, button), (btn) => {
                btn.class = 'btn-hollow'
            })
            handleChangedCustomizations()
        }

        function setSaveCustomizationsOption() {
            handleChangedCustomizations()
        }

        function exportDataToCsv() {
            if (vm.exporting) return

            const filename = 'WF_' + (vm.filenamePart || '') + '_' + moment().format('YYYY-MM-DD') + '.csv'

            mappingProperties = []

            _.each(vm.exportingDetails.mappingOptions, (option) => {
                if (option.include) mappingProperties.push(option)
            })

            const mappingOptionsToSave = {}
            _.each(vm.exportingDetails.mappingOptions, (option, key) => {
                mappingOptionsToSave[key] = {
                    header: option.header,
                    include: option.include,
                }
            })

            const promises = []
            vm.exporting = true

            if (vm.shouldSaveCustomizations && !vm.isTransparencySolution) {
                vm.newCustomizations = {
                    resourceType: vm.customizations.resourceType,
                    topOptions: vm.customizations.topOptions,
                    mapping: mappingOptionsToSave,
                    settings: {
                        fieldSeparator: vm.fieldSeparator,
                        decimalSeparator: vm.decimalSeparator,
                        textDelimiter: vm.textDelimiter,
                        dateTimeFormat: vm.dateTimeFormat,
                    },
                }
                promises.push(saveCustomizations())
            }

            if (!_.isEmpty(vm.exportingDetails) && mappingProperties.length) {
                promises.push(importExportService.exportToCsv(vm.actualItems, mappingProperties, {
                    filename,
                    fieldSep: vm.fieldSeparator,
                    decimalSep: vm.decimalSeparator,
                    txtDelim: vm.textDelimiter,
                    dateTimeFormat: vm.dateTimeFormat,
                }))
            }

            $q.all(promises).then(() => {
                vm.exporting = false
                $timeout()
            })
        }

        function saveCustomizations() {
            return new Promise((resolve, reject) => {
                const currentNetworkSettings = vm.network.settings || {}

                if (!currentNetworkSettings.valueChainSettings) {
                    currentNetworkSettings.valueChainSettings = {}
                }

                if (!currentNetworkSettings.valueChainSettings.exportCustomizations) {
                    currentNetworkSettings.valueChainSettings.exportCustomizations = []
                }

                const existingCustomization = currentNetworkSettings.valueChainSettings.exportCustomizations.find(
                    customization => customization.resourceType === vm.newCustomizations.resourceType,
                )

                if (existingCustomization) {
                    _.assign(existingCustomization, vm.newCustomizations)
                    delete existingCustomization.shouldSaveCustomizations
                } else {
                    currentNetworkSettings.valueChainSettings.exportCustomizations.push(vm.newCustomizations)
                }

                const settingsModel = {
                    objectType: enums.objectType.network,
                    objectId: vm.network.id,
                    items: [],
                }

                _.forEach(currentNetworkSettings, (value, key) => {
                    const preparedValue = dataOps.prepareSettingsValueForSaving(key, value)
                    if (preparedValue === undefined) return

                    settingsModel.items.push({ settingKind: key, value: preparedValue })
                })

                apiProxy('multi.savesettings', dataOps.prepareWfObject(settingsModel))
                    .then((res) => {
                        vm.network.settings = res.actual || res
                        resolve()
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        }

    }
})()
